/** @format */

import React, {useEffect, useState} from 'react';

export const MegaMenuAbout = ({onMouseLeave, onMouseOver, isMobile, display = 'none'}) => {
    const [posts, setPosts] = useState([]);

    const aboutLinks = {
        base: '/about',
        instructional_videos: '/about/instructional-videos',
        template_generator: '/about/template-generator',
        guide_to_custom_labels: '/about/ultimate-guide-to-custom-labels',
        faq: '/about/faq',
        blog: '/blog'
    };

    const contactLinks = {
        contact: '/contact'
    };

    async function fetchAndSaveLast3Posts() {
        // Check if data is stored in sessionStorage and is not older than 24 hours
        const storedData = sessionStorage.getItem('wordpressLast3Posts');
        const storedTimestamp = sessionStorage.getItem('wordpressLast3PostsTimestamp');

        if (storedData && storedTimestamp) {
            const currentTime = new Date().getTime();
            const storedTime = new Date(parseInt(storedTimestamp)).getTime();
            const hoursSinceLastFetch = (currentTime - storedTime) / (1000 * 60 * 60);

            if (hoursSinceLastFetch < 24) {
                // Data is still fresh, no need to fetch again
                setPosts(JSON.parse(storedData));
                return;
            }
        }

        try {
            // Fetch new data
            const response = await fetch('/wp-json/wp/v2/posts?per_page=3&_embed=1');
            if (!response.ok) {
                console.error('Failed to fetch data from WordPress');
            }

            const data = await response.json();

            // Save the fetched data and timestamp to sessionStorage
            const currentTime = new Date().getTime();
            sessionStorage.setItem('wordpressLast3Posts', JSON.stringify(data));
            sessionStorage.setItem('wordpressLast3PostsTimestamp', currentTime);

            // Return the fetched data
            setPosts(data);
        } catch (error) {
            console.error('Error fetching or saving WordPress data:', error);
            throw error;
        }
    }

    useEffect(() => {
        (async () => {
            try {
                await fetchAndSaveLast3Posts();
            } catch (error) {
                console.error('Error fetching or saving WordPress data:', error);
            }
        })();
    }, []);

    return (
        <div
            className="header-23cr_megamenus-toggler megamenus-toggler--about"
            onMouseLeave={!isMobile ? onMouseLeave : null}
            onMouseOver={!isMobile ? onMouseOver : null}
            style={{display}}>
            <nav
                aria-labelledby="sub-nav"
                className="header-23cr_megamenu-container megamenu-container-about">
                <div className="header-23cr_megamenu">
                    <div className="megamenu-23cr_links">
                        {/*  Image Lnk*/}
                        <div className="links-23cr_link link-image">
                            <div className="link-23cr_title">
                                <h3>
                                    <a href={aboutLinks['base']}>About Us</a>
                                </h3>
                                <span className="title-23cr_carat">
                                    <svg
                                        width="8"
                                        height="5"
                                        viewBox="0 0 8 5"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0.166687L4 4.16669L8 0.166687H0Z" />
                                    </svg>
                                </span>
                            </div>
                            <div
                                className="link-image-23cr_image"
                                style={{
                                    backgroundImage: `linear-gradient(0deg, rgba(20, 20, 20, 0.55), rgba(20, 20, 20, 0.55)), url('/images/header_footer/about_us.webp')`
                                }}>
                                <a href={aboutLinks['base']}>
                                    <h6>About Us</h6>
                                </a>
                            </div>
                        </div>
                        {/*  Contact */}
                        <div className="links-23cr_link">
                            <div className="link-23cr_title">
                                <h3>
                                    <a href={contactLinks['contact']}>Contact</a>
                                </h3>
                                <span className="title-23cr_carat">
                                    <svg
                                        width="8"
                                        height="5"
                                        viewBox="0 0 8 5"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0.166687L4 4.16669L8 0.166687H0Z" />
                                    </svg>
                                </span>
                            </div>
                            <div className="link-23cr_links-list link-list-23cr_contact-section">
                                <ul className="links-list-23cr_column">
                                    <li>
                                        <div className="link-23cr_contact_and_address">
                                            <h6>877-277-4682</h6>
                                            <div>
                                                <p>
                                                    2 Task Industrial Court
                                                    <br />
                                                    Greenville, SC 29607
                                                </p>

                                                <p>
                                                    9 AM — 6 PM ET
                                                    <br />
                                                    Monday — Friday
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/*  Resources */}
                        <div className="links-23cr_link">
                            <div className="link-23cr_title">
                                <h3>Resources</h3>
                            </div>
                            <div className="link-23cr_links-list">
                                {/* first column*/}
                                <ul className="links-list-23cr_column column-first">
                                    <li>
                                        <a href={`${aboutLinks['faq']}`} className="d-block">
                                            FAQs
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={`${aboutLinks['instructional_videos']}`}
                                            className="d-block">
                                            Instructional Videos
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={`${aboutLinks['template_generator']}`}
                                            className="d-block">
                                            Template Generator
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href={`${aboutLinks['guide_to_custom_labels']}`}
                                            className="d-block">
                                            The Ultimate Guide
                                            <br />
                                            To Custom Labels
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/*  Industry Insights */}
                        <div className="links-23cr_link">
                            <div className="link-23cr_title">
                                <h3>
                                    <a href={aboutLinks['blog']}>Industry Insights</a>
                                </h3>
                                <span className="title-23cr_carat">
                                    <svg
                                        width="8"
                                        height="5"
                                        viewBox="0 0 8 5"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0.166687L4 4.16669L8 0.166687H0Z" />
                                    </svg>
                                </span>
                            </div>
                            <div className="link-23cr_links-list">
                                <ul className="links-list-23cr_column">
                                    {posts.length > 0 &&
                                        posts?.map(post => (
                                            <li key={post.id}>
                                                <a href={post.link} className="d-block">
                                                    {post.title.rendered}
                                                </a>
                                            </li>
                                        ))}
                                    <li>
                                        <a href={aboutLinks['blog']}>
                                            <h6 className="link-23cr_explore-our-blog">
                                                Explore Our Blog
                                            </h6>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    );
};
